import type { PlantCategory, PlantPersonality, PotSize } from '@/types';

export const categoryChips: { id: PlantCategory | null; label: string }[] = [
  { id: null, label: 'Все' },
  { id: 'TROPICAL', label: '🌴 Тропические' },
  { id: 'SUCCULENT', label: '🪴 Суккуленты' },
  { id: 'CACTUS', label: '🌵 Кактусы' },
  { id: 'ORCHID', label: '🌸 Орхидеи' },
  { id: 'FERN', label: '🌿 Папоротники' },
  { id: 'PALM', label: '🌴 Пальмы' },
  { id: 'FLOWERING', label: '🌺 Цветущие' },
  { id: 'VINE', label: '🍃 Лианы' },
  { id: 'HERB', label: '🌱 Травы' },
  { id: 'CITRUS', label: '🍋 Цитрусовые' },
  { id: 'DECORATIVE_LEAFY', label: '🍀 Декоративно-лиственные' },
  { id: 'AIR_PLANT', label: '🌬️ Воздушные' },
  { id: 'CARNIVOROUS', label: '🪤 Хищные' },
  { id: 'BONSAI', label: '🎋 Бонсай' },
  { id: 'BULB', label: '🌷 Луковичные' },
  { id: 'AQUATIC', label: '💧 Водные' },
  { id: 'VEGETABLE', label: '🍅 Овощи' },
];

export const categoryLabels: Record<PlantCategory, string> = {
  TROPICAL: '🌴 Тропические',
  SUCCULENT: '🪴 Суккуленты',
  CACTUS: '🌵 Кактусы',
  ORCHID: '🌸 Орхидеи',
  FERN: '🌿 Папоротники',
  PALM: '🌴 Пальмы',
  FLOWERING: '🌺 Цветущие',
  VINE: '🍃 Лианы',
  HERB: '🌱 Травы',
  CITRUS: '🍋 Цитрусовые',
  DECORATIVE_LEAFY: '🍀 Декоративно-лиственные',
  AIR_PLANT: '🌬️ Воздушные',
  CARNIVOROUS: '🪤 Хищные',
  BONSAI: '🎋 Бонсай',
  BULB: '🌷 Луковичные',
  AQUATIC: '💧 Водные',
  VEGETABLE: '🍅 Овощи',
};

export const personalities: { id: PlantPersonality; emoji: string; name: string; desc: string }[] = [
  { id: 'FRIENDLY', emoji: '😊', name: 'Дружелюбный', desc: 'Общительный и позитивный' },
  { id: 'SHY', emoji: '😳', name: 'Застенчивый', desc: 'Тихий и скромный' },
  { id: 'DRAMATIC', emoji: '🎭', name: 'Драматичный', desc: 'Эмоциональный и яркий' },
  { id: 'WISE', emoji: '🧘', name: 'Мудрый', desc: 'Философский и спокойный' },
  { id: 'PLAYFUL', emoji: '🎉', name: 'Игривый', desc: 'Весёлый и энергичный' },
];

export const potSizes: { id: PotSize; name: string; desc: string }[] = [
  { id: 'TINY', name: 'Крошечный', desc: 'до 8 см' },
  { id: 'SMALL', name: 'Маленький', desc: '8-12 см' },
  { id: 'MEDIUM', name: 'Средний', desc: '12-20 см' },
  { id: 'LARGE', name: 'Большой', desc: '20-30 см' },
  { id: 'XLARGE', name: 'Очень большой', desc: 'более 30 см' },
];
